<template>
    <div class="home-page public">
        <IdSection :title="titleIdSection" :info="infoIdSection" :height="550">
            <div class="buttons" v-if="!getShowMap">
                <b-button :variant="'primary'" @click="changeShowMap(true)">{{ textButtonIdSection }}</b-button>
            </div>
        </IdSection>

        <div id="top-map">
            <div class="resume-data" v-if="!getShowMap">
                <div class="container">
                    <div class="box">
                        <div class="box-info col-12 col-md-4">
                            <div class="info">
                                <div class="number">{{ registeredPowers }}</div>
                                <div class="text">Potências cadastradas</div>
                            </div>
                        </div>

                        <div class="box-info col-12 col-md-4">
                            <div class="info">
                                <div class="number">{{ registeredInvestors }}</div>
                                <div class="text">Investidores cadastrados</div>
                            </div>
                        </div>

                        <div class="box-info col-12 col-md-4">
                            <div class="info">
                                <div class="number">{{ registeredConnections }}</div>
                                <div class="text">Conexões realizadas</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section v-if="getShowMap">
            <div class="container link-register" @click="$router.push({ name: 'Register' })" v-if="!showRegisterModal">
                Cadastre-se para fazer parte da platafoma
            </div>

            <MapSection>
                <div class="map-register-warning radius-6" v-if="!getIsLogged && showRegisterModal">
                    <div class="icon-header">
                        <img :src="require(`@/assets/alert-circle-warning.svg`)" alt="alert-circle-warning.svg" />
                    </div>

                    <div class="title">Cadastre-se para fazer parte da platafoma</div>

                    <div class="footer-buttons">
                        <b-button variant="light" @click="changeShowMap(false)">Fechar</b-button>
                        <b-button variant="dark" @click="$router.push({ name: 'Register' })">Faça parte</b-button>
                    </div>
                </div>
            </MapSection>
        </section>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import CarouselPP from '@/ui/carousel-pp/CarouselPP'
import IdSection from '@//pages/public/components/landing-page/id-section/IdSection'
import MapSection from '@/pages/public/components/landing-page/map-section/MapSection'

export default {
    components: {
        CarouselPP,
        IdSection,
        MapSection
    },
    props: {
        registeredPowers: {
            type: Number,
            default: 0
        },
        registeredInvestors: {
            type: Number,
            default: 0
        },
        registeredConnections: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            usuario: null,
            showRegisterModal: true,
            titleIdSection: 'Plataforma Potências Periféricas',
            infoIdSection: `Somos uma plataforma com o objetivo de promover encontros e qualificar ainda mais as doações e parcerias que sejam direcionadas às periferias no Brasil.`,
            textButtonIdSection: 'Ver mapa'
        }
    },
    methods: {
        ...mapActions(['setShowMap']),
        changeShowMap(status) {
            if (status) {
                this.showRegisterModal = true
                this.setShowMap(status)
                this.scrollBehavior('top-map')
            } else {
                this.showRegisterModal = false
                this.scrollBehavior('app')
            }
        },
        scrollBehavior(id) {
            const ele = document.getElementById(id)
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        }
    },
    computed: {
        getShowMap() {
            return this.$store.state.showMap
        },
        getIsLogged() {
            return this.$store.state.isLogged
        }
    },
    created() {
        this.usuario = JSON.parse(localStorage.getItem('usuario'))
        this.setShowMap(false)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope src="./HomePage-light-theme.css"></style>
<style scope src="./HomePage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/home-page/HomePage.vue